module.exports = __webpack_public_path__ + "static/media/miaowrite.97c0679d.png";